// pages/module-pages/sites/UpdateSitePage.tsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Site, SiteFormData } from "../../../types/features/Site";
import SiteForm from "../../../components/shared/sites/SiteForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useCustomParams from "../../../hooks/core/useCustomParams";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import useSites from "../../../hooks/features/sites/useSites";

export default function UpdateSitePage() {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const { fetchSiteById, updateSite } = useSites();
  const [site, setSite] = useState<Site | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    loadSite();
  }, [id]);

  const loadSite = async () => {
    if (id) {
      const data = await fetchSiteById(id);
      if (data) {
        setSite(data);
      }
      setLoading(false);
    }
  };

  const handleSubmit = async (data: SiteFormData) => {
    setIsLoading(true);
    const success = await updateSite(id!, data);
    setIsLoading(false);
    if (success) {
      setIsSuccess(true);
      alertSuccess("Site mis à jour avec succès");
      navigate("/admin/sites");
    } else {
      alertError("Erreur lors de la mise à jour du site");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!site) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <p className="text-gray-500">Site non trouvé</p>
        <button
          onClick={() => navigate("/admin/sites")}
          className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
        >
          Retour à la liste
        </button>
      </div>
    );
  }

  return (
    <PageLayout title="Modifier le site" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Modifier le site</h1>
          <p className="text-gray-500 mt-1">Modifiez les informations du site "{site.name}"</p>
        </div>
        <SiteForm
          isSuccess={isSuccess}
          initialData={site}
          isEdit={true}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}